var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMysitesMarkerSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#fca105",
    ry: 23.98374,
    rx: 23.902438,
    id: "svg_1",
    cy: 26.247457,
    cx: 26.000002,
    fillOpacity: "null",
    strokeWidth: 4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#536e7a",
    fill: "#ffffff",
    strokeWidth: 4,
    cx: 26.059011,
    cy: 26.226181,
    id: "svg_2",
    rx: 22.268932,
    ry: 22.539325
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.09828,57.364543l6.91154,-7.42554l6.91154,7.42554l-13.82308,0z",
    id: "svg_4",
    transform: "rotate(179.84815979003906 26.009819030761722,53.65177917480468) ",
    stroke: "#536e7a",
    fill: "#536e7a",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysitesMarkerSelect);
export default __webpack_public_path__ + "static/media/mysites-marker-select.fbc151f758e4e60639e4773387b2c136.svg";
export { ForwardRef as ReactComponent };